/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row } from 'antd';

import { TextField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Button } from '@atoms';

import Form from '../Form';

import { FORM_SINGLE_FIELD } from './constants';
import RichTextField from '@components/molecules/RichTextField';

const BlockForm = ({ onSubmit, buttons, initialValues: initData }) => {
  const [form] = Form.useForm(FORM_SINGLE_FIELD);
  const initialValues = React.useMemo(() => form.deserialize(initData), [form, initData]);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  return (
    <Form
      form={form}
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      layout="vertical"
      labelAlign="left"
      colon={false}
    >
      {buttons && <h2>Edit block</h2>}
      <Row>
        <Col flex="1">
          <Row>
            <Col flex="1">
              <MediaField {...FORM_SINGLE_FIELD.IMAGE} />
              <TextField {...FORM_SINGLE_FIELD.TITLE} />
              <RichTextField {...FORM_SINGLE_FIELD.CONTENT} />
              <TextField {...FORM_SINGLE_FIELD.URL} />
              <TextField {...FORM_SINGLE_FIELD.URL_TEXT} />
            </Col>
          </Row>
          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
                  ADD Block
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default BlockForm;
